import { motion, useReducedMotion } from "framer-motion";

const offset = (direction) => {
  switch (direction) {
    case "down":
      return { y: -40, x: 0 };
    case "left":
      return { x: 40, y: 0 };
    case "right":
      return { x: -40, y: 0 };
    case "none":
      return { x: 0, y: 0 };
    default:
      return { y: 40, x: 0 };
  }
};

/**
 * Gentle scroll-into-view reveal. Defaults to a soft fade + rise.
 * Honours prefers-reduced-motion by rendering statically.
 */
export default function Reveal({
  children,
  as = "div",
  direction = "up",
  delay = 0,
  duration = 0.8,
  amount = 0.25,
  once = true,
  className = "",
  ...rest
}) {
  const reduce = useReducedMotion();
  const MotionTag = motion[as] || motion.div;

  if (reduce) {
    const Tag = as;
    return (
      <Tag className={className} {...rest}>
        {children}
      </Tag>
    );
  }

  const { x, y } = offset(direction);

  return (
    <MotionTag
      className={className}
      initial={{ opacity: 0, x, y }}
      whileInView={{ opacity: 1, x: 0, y: 0 }}
      viewport={{ once, amount }}
      transition={{ duration, delay, ease: [0.22, 1, 0.36, 1] }}
      {...rest}
    >
      {children}
    </MotionTag>
  );
}
